"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var ExtendedField_1 = __importDefault(require("../Field/ExtendedField/ExtendedField"));
var ColorMapTypeField_1 = __importDefault(require("../Field/ColorMapTypeField/ColorMapTypeField"));
var ColorField_1 = __importDefault(require("../Field/ColorField/ColorField"));
var OffsetField_1 = __importDefault(require("../Field/OffsetField/OffsetField"));
var OpacityField_1 = __importDefault(require("../Field/OpacityField/OpacityField"));
var RasterUtil_1 = __importDefault(require("../../../Util/RasterUtil"));
var ColorRampCombo_1 = __importDefault(require("../../RuleGenerator/ColorRampCombo/ColorRampCombo"));
var RuleGeneratorUtil_1 = __importDefault(require("../../../Util/RuleGeneratorUtil"));
var chroma_js_1 = require("chroma-js");
require("./ColorMapEditor.css");
var _get = require('lodash/get');
var _cloneDeep = require('lodash/cloneDeep');
var ColorMapEditor = /** @class */ (function (_super) {
    __extends(ColorMapEditor, _super);
    function ColorMapEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.updateColorMap = function (prop, value) {
            var _a = _this.props, colorMap = _a.colorMap, onChange = _a.onChange;
            var newColorMap;
            if (colorMap) {
                newColorMap = _cloneDeep(colorMap);
            }
            else {
                newColorMap = {
                    type: 'ramp'
                };
            }
            newColorMap[prop] = value;
            if (onChange) {
                onChange(newColorMap);
            }
        };
        _this.onExtendedChange = function (extended) {
            _this.updateColorMap('extended', extended);
        };
        _this.onTypeChange = function (type) {
            _this.updateColorMap('type', type);
        };
        /**
         * Creates the number of default ColorMapEntries according to specified
         * number of classes. Table will be updated accordingly.
         *
         */
        _this.onNrOfClassesChange = function (value) {
            var colorRamp = _this.state.colorRamp;
            var cmEntries = _get(_this.props, 'colorMap.colorMapEntries');
            var newCmEntries = cmEntries ? _cloneDeep(cmEntries) : [];
            if (value > newCmEntries.length) {
                while (newCmEntries.length < value) {
                    newCmEntries.push(RasterUtil_1.default.generateColorMapEntry());
                }
            }
            else {
                while (newCmEntries.length > value) {
                    newCmEntries.pop();
                }
            }
            _this.applyColors(colorRamp, newCmEntries);
            _this.updateColorMap('colorMapEntries', newCmEntries);
        };
        _this.onColorRampChange = function (colorRamp) {
            var cmEntries = _get(_this.props, 'colorMap.colorMapEntries');
            var newCmEntries = _this.applyColors(colorRamp, _cloneDeep(cmEntries));
            _this.updateColorMap('colorMapEntries', newCmEntries);
            _this.setState({
                colorRamp: colorRamp
            });
        };
        /**
         * Applies the colors of the selected colorRamp to the colorMapEntries.
         * Important: This method modifies the array of colorMapEntries 'cmEntries'.
         *
         * @return {ColorMapEntry[]} cmEntries, the modified array of colorMapEntries.
         */
        _this.applyColors = function (colorRamp, cmEntries) {
            if (cmEntries === void 0) { cmEntries = []; }
            var colorRamps = _this.props.colorRamps;
            var ramp = colorRamps[colorRamp] ?
                colorRamps[colorRamp] : colorRamps[Object.keys(colorRamps)[0]];
            var colors = RuleGeneratorUtil_1.default.generateColors(ramp, cmEntries.length);
            cmEntries.forEach(function (entry, idx) {
                entry.color = colors[idx];
            });
            return cmEntries;
        };
        /**
         * Updates property 'key' with 'value' of colorMapEntry at position 'index'.
         * Creates a new colorMapEntry if it did not exist yet.
         */
        _this.setValueForColorMapEntry = function (idx, key, value) {
            var cmEntries = _get(_this.props, 'colorMap.colorMapEntries');
            var newCmEntries;
            if (cmEntries) {
                newCmEntries = _cloneDeep(cmEntries);
                newCmEntries[idx][key] = value;
            }
            else {
                newCmEntries = [{}];
                newCmEntries[0][key] = value;
            }
            _this.updateColorMap('colorMapEntries', newCmEntries);
        };
        _this.getColorMapRecords = function () {
            var cmEntries = _get(_this.props, 'colorMap.colorMapEntries');
            if (!cmEntries) {
                return [];
            }
            else {
                return cmEntries.map(function (entry, index) {
                    return __assign({ key: index }, entry);
                });
            }
        };
        /**
         * Renderer method for the label column.
         */
        _this.labelRenderer = function (text, record) {
            var locale = _this.props.locale;
            var input = (React.createElement(antd_1.Input, { className: "gs-colormap-label-input", value: record.label, onChange: function (event) {
                    var target = event.target;
                    _this.setValueForColorMapEntry(record.key, 'label', target.value);
                } }));
            return (React.createElement(antd_1.Popover, { content: record.label, title: locale.labelLabel }, input));
        };
        /**
         * Renderer method for the color column.
         */
        _this.colorRenderer = function (text, record) {
            var input = (React.createElement(ColorField_1.default, { color: record.color, onChange: function (color) {
                    _this.setValueForColorMapEntry(record.key, 'color', color);
                } }));
            return input;
        };
        /**
         * Renderer method for the quantity column.
         */
        _this.quantityRenderer = function (text, record) {
            var input = (React.createElement(OffsetField_1.default, { className: "gs-colormap-quantity-input", offset: record.quantity, onChange: function (value) {
                    _this.setValueForColorMapEntry(record.key, 'quantity', value);
                } }));
            return input;
        };
        /**
         * Renderer method for the opacity column.
         */
        _this.opacityRenderer = function (text, record) {
            var input = (React.createElement(OpacityField_1.default, { className: "gs-colormap-opacity-input", opacity: record.opacity, onChange: function (opacity) {
                    _this.setValueForColorMapEntry(record.key, 'opacity', opacity);
                } }));
            return input;
        };
        /**
         * Creates the columns for the table.
         */
        _this.getColumns = function () {
            var locale = _this.props.locale;
            var columns = [{
                    title: locale.colorLabel,
                    dataIndex: 'color',
                    render: _this.colorRenderer
                }, {
                    title: locale.quantityLabel,
                    dataIndex: 'quantity',
                    render: _this.quantityRenderer
                }, {
                    title: locale.labelLabel,
                    dataIndex: 'label',
                    render: _this.labelRenderer
                }, {
                    title: locale.opacityLabel,
                    dataIndex: 'opacity',
                    render: _this.opacityRenderer
                }];
            return columns;
        };
        _this.state = {
            colorRamp: Object.keys(props.colorRamps)[0]
        };
        return _this;
    }
    ColorMapEditor.prototype.render = function () {
        var _a = this.props, colorMap = _a.colorMap, colorRamps = _a.colorRamps, locale = _a.locale;
        var colorRamp = this.state.colorRamp;
        var formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        };
        // make sure colorMapEntries does exist
        var colorMapEntries = _get(colorMap, 'colorMapEntries');
        if (!colorMapEntries) {
            colorMapEntries = [];
        }
        var nrOfClasses = colorMapEntries.length;
        return (React.createElement("div", { className: "gs-colormap-symbolizer-editor" },
            React.createElement("div", { className: "gs-colormap-header-row" },
                React.createElement(antd_1.Form.Item, __assign({}, formItemLayout),
                    React.createElement("span", null, locale.titleLabel)),
                React.createElement(antd_1.Form.Item, __assign({ label: locale.typeLabel }, formItemLayout),
                    React.createElement(ColorMapTypeField_1.default, { colorMapType: _get(colorMap, 'type'), onChange: this.onTypeChange })),
                React.createElement(antd_1.Form.Item, __assign({ label: locale.nrOfClassesLabel }, formItemLayout),
                    React.createElement(antd_1.InputNumber, { min: 0, max: 255, value: nrOfClasses, onChange: this.onNrOfClassesChange })),
                React.createElement(antd_1.Form.Item, __assign({ label: locale.colorRampLabel }, formItemLayout),
                    React.createElement(ColorRampCombo_1.default, { onChange: this.onColorRampChange, colorRamp: colorRamp, colorRamps: colorRamps })),
                React.createElement(antd_1.Form.Item, __assign({ label: locale.extendedLabel }, formItemLayout),
                    React.createElement(ExtendedField_1.default, { extended: _get(colorMap, 'extended'), onChange: this.onExtendedChange }))),
            React.createElement(antd_1.Table, { className: "gs-colormap-table", columns: this.getColumns(), dataSource: this.getColorMapRecords(), pagination: {
                    position: 'bottom',
                    defaultPageSize: 5
                }, size: "small" })));
    };
    ColorMapEditor.componentName = 'ColorMapEditor';
    ColorMapEditor.defaultProps = {
        locale: en_US_1.default.GsColorMapEditor,
        colorRamps: __assign({ GeoStyler: ['#E7000E', '#F48E00', '#FFED00', '#00943D', '#272C82', '#611E82'], GreenRed: ['#00FF00', '#FF0000'] }, chroma_js_1.brewer)
    };
    return ColorMapEditor;
}(React.Component));
exports.ColorMapEditor = ColorMapEditor;
exports.default = LocaleWrapper_1.localize(ColorMapEditor, ColorMapEditor.componentName);
//# sourceMappingURL=ColorMapEditor.js.map